import { ReactNode } from 'react';

import {
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { Box } from '@mui/system';


interface ILayoutBaseDePaginaProps {
  children: React.ReactNode;
  barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDeDashboard: React.FC<
  ILayoutBaseDePaginaProps
> = ({ children, barraDeFerramentas }) => {
  const smDown = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('sm')
  );

  const mdDown = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('md')
  );

  const theme = useTheme();


  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: theme.palette.background.default,
      }}
    >
      {/* Respiro no topo (o botão de menu do celular saiu — a navegação lá
          é a barra de baixo, ver AppMobile.tsx). */}
      <Box
        flexShrink={0}
        height={theme.spacing(
          smDown ? 1 : mdDown ? 8 : 0
        )}
      />

      {/* TOOLBAR */}
      {barraDeFerramentas && (
        <Box flexShrink={0}>
          {barraDeFerramentas}
        </Box>
      )}

      {/* CONTEUDO */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          px: { xs: 1, sm: 2 },
          pb: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};